// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"547":"66e2aeaa","607":"025d291d","787":"7c188a15","909":"e05c5f47"}[chunkId] + ".chunk.js";
};